module.exports = __webpack_public_path__ + "static/img/Metal Slug Awakening.07060492.png";